/**
* Certs Spec Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Certs Spec Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'certs-spec-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const button = document.querySelector( '.grid-view-more-btn' );
      const grid = document.querySelector( '.cert-spec-cards__grid' );
      button.addEventListener( 'click', function() {
        grid.classList.toggle( 'show' );
        if ( button.textContent === 'View More' ) {
          button.textContent = 'View Less';
        } else {
          button.textContent = 'View More';
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'certs-spec-cards', COMPONENT );
} )( app );
